import React from "react";

export function TableLikeText({title, value, className=""}) {
    return <div className={`d-flex gap-2 ${className}`}>
        <div className="text-body-secondary">{title}:</div>
        <div>{value}</div>
    </div>
}